import { Skeleton } from '@nextui-org/react';

const SkeletonMarketList = () => {
  const arr = Array.from(Array(12).keys());

  return (
    <div className="-mx-[10px] flex flex-wrap">
      {arr.map((item) => (
        <>
          <div key={item} className="w-[calc(100%/6)] px-[10px] pb-[20px] lg:w-[50%] sm:!w-full">
            <div className="overflow-hidden rounded-[28px] bg-white shadow-[0px_4px_8px_4px_rgba(199,205,231,0.25)]">
              <Skeleton className="h-[300px] w-full rounded-t-[28px]" />
            </div>
          </div>
        </>
      ))}
    </div>
  );
};

export default SkeletonMarketList;
